module.exports = __webpack_public_path__ + "static/media/deer_stone_text_03.1e25619e.jpg";